const main = {
    namespaced: true,
    state: {
        searchContent: '',
        pagination: {
            itemPerPage: 9,
            currentPage: 1,
            total: 0,
            range: 2
        },
        sorting: {
            column: 'name',
            direction: 'asc'
        },
        filters: {
        }
    },
    mutations: {
        setSearch(state, value) {
            state.searchContent = value;
        },
        setSorting(state, value) {
            state.sorting = value;
        },
        setPagination(state, value)
        {
            for (let key in value) {
                state.pagination[key] = value[key] ;
            }
        },
        setFilters(state, value) {
            state.filters = value;
        },
    }
};

export default main;
